import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, numberFormat, responsivefy} from '../functions'
import * as topojson from "topojson";
export default function (chart, divId, vizName, filterParam, forwardflag) {
    var url1 = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    var url2 = '/api/fetchDataWithParam/' + chart.data.vizSpecific4 + '/Any'
    console.log("Chart vizName called:", vizName, filterParam)

    axios.all([
        axios({url: '/json/geojsonfiles/India_States.json', baseURL: '', method: 'GET'}),
        //axios({ url: '/json/forewarn_data_heatmap.json', baseURL: '', method: 'GET' }),
        //axios({ url: '/json/revenue_by_state.json', baseURL: '', method: 'GET' })

        axios.post(url1, filterParam),
        axios.post(url2, filterParam)

    ]).then(axios.spread(function (r0, r1, r2) {

        //Assigning to the variables from axios output
        var topo = r0.data;
        var coordata = r1.data;
        var revenue_data = r2.data.rowsData
        console.log("topo: ", topo)
        console.log("coordata: ", coordata)
        console.log("revenue_data: ", revenue_data)

        //Mapping the required variables from above dataset using nest functions
        var datanest = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric3
                })
            })
            .map(revenue_data);

        var datanest1 = d3.nest()
            .key(function (d) {
                return d.dim4_name;
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric4
                })
            })
            .map(coordata);
        forwardflag = true
        // Data and color scale
        var dataRev = d3.map(datanest)
        var dataRev1 = d3.map(datanest1)

        //created for the scale domain 	by mapping the cost and revenue
        let cost = coordata.map(function (d) {
            return d.metric5
        })

        let revenue = coordata.map(function (d) {
            return d.metric4
        })

        //Blue color scale Need to parameterize the domain values from metrics
        var x1AxisLabel = d3.scaleLinear()
            .domain([Math.min(...revenue), Math.max(...revenue)])
            .range(['#2897bf', '#081d58']);

        //Green color scale Need to parameterise the domain values from metrics
        var x2AxisLabel = d3.scaleLinear()
            .domain([0, d3.max(dataRev.values())])
            .range(['#ecf8fa', '#00441b']);

        //Red color scale Need to parameterise the domain values from metrics
        var x3AxisLabel = d3.scaleLinear()
            .domain([Math.min(...cost), Math.max(...cost)])
            .range(['#e65339', '#7f0000']);


        //Circle radius scale for Blue circles Need to parameterise the domain values
        var radiusBlue = d3.scaleSqrt()
            .domain([Math.min(...revenue), Math.max(...revenue)])
            .range([1, 5]);

        //Circle radius scale for red circles Need to parameterise the domain values
        var radiusRed = d3.scaleSqrt()
            .domain([Math.min(...cost), Math.max(...cost)])
            .range([1, 5]);

        function responsivefylabel(svg) {
            var container = d3.select(svg.node().parentNode),
                width = parseInt(svg.style('width')),
                height = parseInt(svg.style('height')),
                aspect = width / height;

            svg.attr('viewBox', '0 0 ' + width + ' ' + height)
                .attr('perserveAspectRatio', 'xMinYMid')
                .call(resize)

            //d3.select(window).on('resize.' + container.attr('id'), resize)
            window.addEventListener("resize", resize)

            function resize() {
                var targetWidth = parseInt(container.style('width'))
                svg.attr('width', targetWidth / 2)
                svg.attr('height', Math.round(targetWidth / 2 / aspect))
            }
        }

        function responsivefylegend(svg) {
            var container = d3.select(svg.node().parentNode),
                width = parseInt(svg.style('width')),
                height = parseInt(svg.style('height')),
                aspect = width / height;

            svg.attr('viewBox', '0 0 ' + width + ' ' + height)
                .attr('perserveAspectRatio', 'xMinYMid')
                .call(resize)

            window.addEventListener("resize", resize)

            function resize() {
                var targetWidth = parseInt(container.style('width'))
                svg.attr('width', targetWidth / 2)
                svg.attr('height', Math.round(targetWidth / 6.5 / aspect))
            }
        }

        if (forwardflag == true) {
            //Declaring to remove the existed s
            svg = d3.selectAll("svg").remove();

            // The svg assigning the declared html element in the html
            var svg = d3.select(divId)
                .append("svg")
                .attr("width", chart.width) // getting the width of the svg
                .attr("height", chart.height) // getting the height of svg
                .attr("width", "100%")
                .call(responsivefy)

            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')
            /* d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
          let y1tip = tooltip_class()

          y1tip.attr('class', 'd3-tip'+divId.id)
                  .html((d) =>{ return "State"+ colonAnnotation+ d.properties.state_name })

          svg.call(y1tip);*/

            //Declaring the projection for the map
            var projection = d3.geoMercator()
                .fitExtent([[0, 0], [chart.width - 400, chart.height]], topo);

            //Assigning the projection scale into the path
            var path = d3.geoPath().projection(projection);

            // Draw the map
            svg.append("g")
                .selectAll("path")
                .data(topo.features) // passing the geojson array of features
                .enter()
                .append("path") //passing the path variable here to draw the map outline
                .style("stroke", "black") //outline color tobe black
                .attr("fill", function (d) {
                    d.revenue_by_state = dataRev.get(d.properties.state_name) || 0; //Getting the revenue by statename from Datarev array
                    return x2AxisLabel(d.revenue_by_state); //Filling the states based on the revenue
                })
                .attr("d", path)
                // on the same path
                .on('click', function (d) { // function for clicked element
                    d3.select('.selected').classed('selected', false)
                    d3.select(this).classed('selected', true)
                    stateMap(d.properties.state_name) //by clicking it will directs to function with a parameter name
                })
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + d.properties.state_name)
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            /*.on("mouseover", y1tip.show)
             .on("mouseout", y1tip.hide)*/
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            //Creating a circle container using g element of svg
            var circles = svg.selectAll("g").data(coordata).enter();

            //Displaying City, Revenue, Cost and Margin on the tooltip
            /*d3.select(".d3-tipmap"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
          let y2tip = tooltip_class()

          y2tip.attr('class', 'd3-tipmap'+divId.id)
                    .html((d) =>{
                      return (
                          "City"+ colonAnnotation+ d.dim5_name+"<br/>"+ "<span style= 'color:blue'>"
                          + "Revenue"+ colonAnnotation+ numberFormat(d.metric4)+ "</span>"+ "<br/>"
                          + "<span style ='color:red'> "+ " Cost"+ colonAnnotation+ numberFormat(d.metric5) + "</span>"
                          + "<br/>" + "Margin"+ colonAnnotation+ Math.round(d.metric4/d.metric5) + '%'
                      )
                    })

          svg.call(y2tip);*/

            circles.append("circle")  //Appending the blue circle on map
                .attr("cx", function (d) {
                    return projection([d.metric2, d.metric1])[0]; //Fetching the lat long and assigning long to cx variable
                })
                .attr("cy", function (d) {
                    return projection([d.metric2, d.metric1])[1]; //Fetching the lat long and assigning the lat to cy variable
                })
                .attr("r", function (d) {
                    return radiusBlue(d.metric4 / 2);
                }) //Sizing the circle radius to revenue
                .attr("fill", function (d) {
                    return x1AxisLabel(d.metric4);
                }) // Filling the color with revenue
                .style("opacity", 0.85)

            circles.append("circle") //Appending the red circle on map
                .attr("cx", function (d) {
                    return projection([d.metric2, d.metric1])[0]; //Fetching the lat long and assigning long to cx variable
                })
                .attr("cy", (d) => {
                    return projection([d.metric2, d.metric1])[1]
                }) //Fetching the lat long and assigning the lat to cy variable
                .attr("r", (d) => {
                    return radiusRed(d.metric5);
                }) //Sizing the circle radius to cost
                .attr("fill", (d) => {
                    return x3AxisLabel(d.metric5);
                })  // Filling the color with cost
                .style("opacity", 0.85)
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x2MetricTooltip + colonAnnotation + d.dim5_name + "<br/>" + "<span style= 'color:blue'>"
                        + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric4) + "</span>" + "<br/>"
                        + "<span style ='color:red'>  " + chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric5) + "</span>"
                        + "<br/>" + chart.y1DataFieldName + colonAnnotation + Math.round(d.metric4 / d.metric5).toFixed(2)
                    )
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            /*.on("mouseover", y2tip.show)
                 .on("mouseout", y2tip.hide)*/

            // Add the label for the bubble
            svg.selectAll(".city-label")
                .data(coordata)
                .enter()
                .append("text")
                .attr("class", "city-label")
                .attr("x", (d) => {
                    return projection([d.metric2, d.metric1])[0]
                })
                .attr("y", (d) => {
                    return projection([d.metric2, d.metric1])[1]
                })
                .text((d) => {
                    return d.dim5_name
                })
                .attr("dx", 10) //Moving the label little to right
                .attr("dy", 5) //Moving the label littlt to belows

            //sort bars based on value
            var topstate = revenue_data.sort(((a, b) => b.metric3 - a.metric3)).slice(0, 3)

            topstate.sort(function (a, b) {
                return d3.ascending(a.metric3, b.metric3);
            })

            var topstatelabel = d3.select(divId).append("svg")
                .attr("width", 500)
                .attr("height", 200)
                .call(responsivefylabel)
                .attr("class", "toplabel")
                .append("g")
                .attr("transform", "translate(250,10)")

            var x1Scale = d3.scaleLinear()
                .range([0, 500])
                .domain([0, d3.max(topstate, (d) => {
                    return d.metric3
                })]);

            var y1Scale = d3.scaleBand()
                .range([90, 0], .1)
                .domain(topstate.map((d) => {
                    return d.dim3_name
                }));

            //make y axis to show bar names
            var y1AxisLabel = d3.axisLeft(y1Scale).tickSize(0)

            var gy = topstatelabel
                .append("g")
                .attr("class", "gyaxis")
                .call(y1AxisLabel)
                .selectAll("text")
                .attr("y", -4)
                .attr("x", -10)
                .style("text-anchor", "end");

            console.warn(gy)

            var bars = topstatelabel.selectAll(".bar").data(topstate).enter().append("g")

            //append rects
            bars.append("rect")
                .attr("class", "bar")
                .attr("y", (d) => {
                    return y1Scale(d.dim3_name);
                })
                .attr("height", y1Scale.bandwidth() / 2)
                .attr("x", 0)
                .attr("width", (d) => {
                    return x1Scale(d.metric3) / 3
                })
                .attr("fill", (d) => {
                    return x2AxisLabel(d.metric3)
                })

            //add a value label to the right of each bar
            bars.append("text")
                .attr("class", "label")
                //y position of the label is halfway down the bar
                .attr("y", (d) => {
                    return y1Scale(d.dim3_name) + y1Scale.bandwidth() / 3 + 4
                })
                //x position is 3 pixels to the right of the bar
                .attr("x", (d) => {
                    return x1Scale(d.metric3) / 3 + 3
                })
                .text((d) => {
                    return d.metric3
                })
                .style('font-size', '10px');
        }
        //Function for state drilldown map
        //after click on stat coordinates it will triggers to this function
        function stateMap(map) {
            var state_name = 'geojsonfiles/india_country_states/' + map + '.json'  // Giving the file path (state_name as a parameter into d3.json load)

            //Declaring to remove the existed svg
            var svg = d3.selectAll("svg").remove();

            //	The svg container for drawing map in d3
            svg = d3.select(divId)
                .append('svg')
                .attr('width', chart.width)
                .attr('height', chart.height)
                .call(responsivefy)

            //Loading the data for state level data
            axios({url: '/json/' + state_name, baseURL: '', method: 'GET'}).then(res => {
                let topology = res.data;

                //created for fitting the outline boundaries and it will turn into a geojson
                var topo2 = topojson.feature(topology, topology.objects.state)

                //Declaring the projection for state level map
                var projection = d3.geoMercator().fitExtent([[0, 0], [chart.width - 400, chart.height]], topo2);//fitting the map into width and height

                /*d3.select(".d3-tipmap"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
              let y3tip = tooltip_class()

              y3tip.attr('class', 'd3-tipmap'+divId.id)
                           .html((d) =>{
                              return "District"+ colonAnnotation+ d.properties.NAME_2
                           })

              svg.call(y3tip);*/
                //Assigning the projection scale into path
                var path1 = d3.geoPath().projection(projection);

                //Extracting the state level coordinates
                var districts = topojson.feature(topology, topology.objects.state).features

                svg.selectAll("path1")
                    .data(districts)
                    .enter()
                    .append("path")
                    .attr("d", path1)
                    .attr("class", "path-map")
                    .attr("fill", function (d) {
                        d.revenue_by_district = dataRev1.get(d.properties.NAME_2) || 0; //Getting the revenue by statename from Datarev array
                        return x2AxisLabel(d.revenue_by_district); //Filling the states based on the revenue
                    })
                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div.html(chart.x1DataFieldName + colonAnnotation + d.properties.NAME_2)
                            .style("left", (d3.event.layerX) + "px")
                            .style("top", (d3.event.layerY) + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0)
                    })
                /*.on("mouseover", y3tip.show)
                  .on("mouseout", y3tip.hide)*/
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

                /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
              let y4tip = tooltip_class()

              y4tip.attr('class', 'd3-tip'+divId.id)
                             .html((d) =>{
                                  return ("City"+ colonAnnotation+ d.dim5_name+"<br/>"+ "<span style= 'color:blue'>"+
                                           "Revenue"+ colonAnnotation+ d.metric4+ "</span>"+ "<br/>"+ "<span style ='color:red'> "+
                                           "Cost"+ colonAnnotation+ d.metric5 + "</span>"+ "<br/>" +
                                           "Margin"+ colonAnnotation+ Math.round(d.metric4/d.metric5)+ '%'
                                  )
                             })

              svg.call(y4tip);*/

                var circles = svg.selectAll("g").data(coordata).enter();

                circles.append("circle")  //Appending the blue circle on map
                    .attr("cx", function (d) {
                        return projection([d.metric2, d.metric1])[0]; //Fetching the lat long and assigning long to cx variable
                    })
                    .attr("cy", function (d) {
                        return projection([d.metric2, d.metric1])[1]; //Fetching the lat long and assigning the lat to cy variable
                    })
                    .attr("r", function (d) {
                        return map === d.dim2_name ? radiusBlue(d.metric4) : '0';
                    }) //Sizing the circle radius to revenue
                    .attr("fill", function (d) {
                        return map == d.dim2_name ? x1AxisLabel(d.metric4) : 'white';
                    }) // Filling the color with revenue
                    .style("opacity", 0.85)

                circles.append("circle") //Appending the red circle on map
                    .attr("cx", (d) => {
                        return projection([d.metric2, d.metric1])[0]
                    }) //Fetching the lat long and assigning long to cx variable
                    .attr("cy", (d) => {
                        return projection([d.metric2, d.metric1])[1]
                    }) //Fetching the lat long and assigning the lat to cy variable
                    .attr("r", (d) => {
                        return map === d.dim2_name ? radiusRed(d.metric5) : '0';
                    }) //Sizing the circle radius to cost
                    .attr("fill", (d) => {
                        return map == d.dim2_name ? x3AxisLabel(d.metric5) : 'white';
                    })  // Filling the color with cost
                    .style("opacity", 0.85)
                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div.html("City" + colonAnnotation + d.dim5_name + "<br/>" + "<span style= 'color:blue'>"
                            + "Revenue" + colonAnnotation + numberFormat(d.metric4) + "</span>" + "<br/>"
                            + "<span style ='color:red'> " + " Cost" + colonAnnotation + numberFormat(d.metric5) + "</span>"
                            + "<br/>" + "Margin" + colonAnnotation + numberFormat(Math.round(d.metric4 / d.metric5)) + '%'
                        )
                            .style("left", (d3.event.layerX) + "px")
                            .style("top", (d3.event.layerY) + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0)
                    })
                /*.on("mouseover", y4tip.show)
                    .on("mouseout", y4tip.hide)
                   .on('contextmenu',  contextMenu(downloadData));*/ //commented due to hardcoding

                //append the label with text to child svg
                svg.selectAll(".city-label")
                    .data(coordata)
                    .enter()
                    .append("text")
                    .attr("class", "city-label")
                    .attr("x", (d) => {
                        return projection([d.metric2, d.metric1])[0]
                    })
                    .attr("y", (d) => {
                        return projection([d.metric2, d.metric1])[1]
                    })
                    .text((d) => {
                        return map == d.dim2_name ? d.dim5_name : null
                    })
                    .attr("dx", 10) //Moving the label little to right
                    .attr("dy", 5) //Moving the label littlt to belows
            })   //end for data function


            var topcity = coordata.map(function (d) {
                return map == d.dim2_name ? d : 0
            })

            var topcity1 = topcity.filter(function (d) {
                return d !== 0;
            })

            var topcitylabel = d3.select(divId).append("svg")
                .attr("width", 500)
                .attr("height", 200)
                .call(responsivefylabel)
                .attr("class", "toplabel")
                .append("g")
                .attr("transform", "translate(285,10)");

            var x2Scale = d3.scaleLinear()
                .range([0, 500])
                .domain([0, d3.max(topcity1, (d) => {
                    return d.metric4
                })]);

            var y2Scale = d3.scaleBand()
                .range([40, 0], .1)
                .domain(topcity1.map((d) => {
                    return d.dim5_name
                }));


            //make y axis to show bar names
            var y2AxisLabel = d3.axisLeft(y2Scale).tickSize(0)
            //no tick marks

            var gy = topcitylabel.append("g")
                .attr("class", "gyaxis")
                .call(y2AxisLabel)
                .selectAll("text")
                .attr("y", -4)
                .attr("x", -10)
                .style("text-anchor", "end");

            console.warn(gy)

            var bars = topcitylabel.selectAll(".bar")
                .data(topcity1)
                .enter()
                .append("g")

            //append rects
            bars.append("rect")
                .attr("class", "bar")
                .attr("y", (d) => {
                    return y2Scale(d.dim5_name)
                })
                .attr("height", y2Scale.bandwidth() / 2)
                .attr("x", 0)
                .attr("width", (d) => {
                    return x2Scale(d.metric4) / 3
                })
                .attr("fill", (d) => {
                    return x2AxisLabel(d.metric4)
                })

            //add a value label to the right of each bar
            bars.append("text")
                .attr("class", "label")
                .attr("y", (d) => {
                    return y2Scale(d.dim5_name) + y2Scale.bandwidth() / 3 + 4
                })//y position of the label is halfway down the bar
                .attr("x", (d) => {
                    return x2Scale(d.metric4) / 3 + 3
                })//x position is 3 pixels to the right of the bar
                .text((d) => {
                    return numberFormat(d.metric4)
                })
                .style('font-size', '10px');


            //for drawing the legend.we are declaring the domains with scale
            var green = d3.scaleLinear().domain(x2AxisLabel.domain()).range([200, 0])

            //Axis declaration for legend
            var greenAxis = d3.axisRight(green).ticks(10).tickFormat(numberFormat)

            //creating legend for the state wise heatmap color
            //creating the key variable for legend scale
            var key = d3.select(divId)
                .append("svg")
                .attr("width", 120)
                .attr("height", 215)
                .call(responsivefylegend)
                .attr("class", "legend-map")

            //creating the color legend and appending to key
            var y1legend = key.append("defs")
                .append("svg:linearGradient")
                .attr("id", "gradient")
                .attr("x1", "100%")
                .attr("y1", "0%")
                .attr("x2", "100%")
                .attr("y2", "100%")
                .attr("spreadMethod", "pad")

            //appending the high color to legend
            y1legend.append("stop")
                .attr("offset", "0%")
                .attr("stop-color", '#00441b')
                .attr("stop-opacity", 1);

            //appending the low color to legend
            y1legend.append("stop")
                .attr("offset", "100%")
                .attr("stop-color", '#ecf8fa')
                .attr("stop-opacity", 1);

            //appending the rectangle legend to the key scale
            key.append("rect")
                .attr("width", 20)
                .attr("height", 214)
                .style("fill", "url(#gradient)")
                .attr("transform", "translate(0,10)");

            //calling the axis scale legend and append to the key
            key.append("g")
                .attr("class", "y axis")
                .attr("transform", "translate(21,10)")
                .call(greenAxis)

        } //end for clicked element function

        //for drawing the legend.we are declaring the domains with scale
        var green = d3.scaleLinear().domain(x2AxisLabel.domain()).range([200, 0])

        //Axis declaration for legend
        var greenAxis = d3.axisRight(green).ticks(10).tickFormat(numberFormat)

        //creating legend for the state wise heatmap color
        //creating the key variable for legend scale
        var key = d3.select(divId)
            .append("svg")
            .attr("width", 120)
            .attr("height", 215)
            .call(responsivefylegend)
            .attr("class", "legend-map")

        //creating the color legend and appending to key
        var y2legend = key.append("defs")
            .append("svg:linearGradient")
            .attr("id", "gradient")
            .attr("x1", "100%")
            .attr("y1", "0%")
            .attr("x2", "100%")
            .attr("y2", "100%")
            .attr("spreadMethod", "pad")

        //appending the high color to legend
        y2legend.append("stop")
            .attr("offset", "0%")
            .attr("stop-color", '#00441b')
            .attr("stop-opacity", 1);

        //appending the low color to legend
        y2legend.append("stop")
            .attr("offset", "100%")
            .attr("stop-color", '#ecf8fa')
            .attr("stop-opacity", 1);

        //appending the rectangle legend to the key scale
        key.append("rect")
            .attr("width", 20)
            .attr("height", 214)
            .style("fill", "url(#gradient)")
            .attr("transform", "translate(0,10)");

        //calling the axis scale legend and append to the key
        key.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(21,10)")
            .call(greenAxis)
    }))
}
